import {
  SETLISTDATA,
  SETCOUNTRYLINKRESTRICTIONFLAG,
  SETTITLEDATA,
  SETPHONEMESSAGEDATA,
  SETSMSMESSAGEDATA,
  SETEMAILMESSAGEDATA,
  SETCONTACTDATA,
  SETDELAYDATA,
  SETNOTIFYDATA,
  SETDISTANCEFLAGDATA,
  SETDISTANCEDATA,
  SETWORKERTYPESDATA,
  SETLANGUAGEDATA,
  SETENGLISHPOSITIVERESPONSEDATA,
  SETENGLISHNEGATIVERESPONSEDATA,
  SETSPANISHPOSITIVERESPONSEDATA,
  SETSPANISHNEGATIVERESPONSEDATA,
  SETSCHEDULEDATA,
  SETCIDATA,
  SETLISTINPUTDATA,
  SETLISTINPUTTYPE,
  HOMEPAGECREATE,
  HOMEPAGECREATEERROR,
  FETCH2,
  SELECTIONS,
} from './actionType'
import axios from 'axios'
import tapConfig from '../../tapConfig'

export function setListData(data) {
  return {
    type: SETLISTDATA,
    data: data,
  }
}
export function setCountryLinkRestrictionFlag(data) {
  return {
    type: SETCOUNTRYLINKRESTRICTIONFLAG,
    data: data,
  }
}
export function setListSelectionData(data) {
  return {
    type: SELECTIONS,
    data: data,
  }
}
export function setTitleData(data) {
  return {
    type: SETTITLEDATA,
    data: data,
  }
}
export function setPhoneMessageData(data) {
  return {
    type: SETPHONEMESSAGEDATA,
    data: data,
  }
}
export function setSMSMessageData(data) {
  return {
    type: SETSMSMESSAGEDATA,
    data: data,
  }
}
export function setEmailMessageData(data) {
  return {
    type: SETEMAILMESSAGEDATA,
    data: data,
  }
}
export function setContactData(data) {
  return {
    type: SETCONTACTDATA,
    data: data,
  }
}
export function setDelayData(data) {
  return {
    type: SETDELAYDATA,
    data: data,
  }
}
export function setNotifyData(data) {
  return {
    type: SETNOTIFYDATA,
    data: data,
  }
}
export function setDistanceFlagData(data) {
  return {
    type: SETDISTANCEFLAGDATA,
    data: data,
  }
}
export function setDistanceData(data) {
  return {
    type: SETDISTANCEDATA,
    data: data,
  }
}
export function setWorkerTypesData(data) {
  return {
    type: SETWORKERTYPESDATA,
    data: data,
  }
}
export function setLanguageData(data) {
  return {
    type: SETLANGUAGEDATA,
    data: data,
  }
}
export function setEnglishPositiveResponseData(data) {
  return {
    type: SETENGLISHPOSITIVERESPONSEDATA,
    data: data,
  }
}
export function setEnglishNegativeResponseData(data) {
  return {
    type: SETENGLISHNEGATIVERESPONSEDATA,
    data: data,
  }
}
export function setSpanishPositiveResponseData(data) {
  return {
    type: SETSPANISHPOSITIVERESPONSEDATA,
    data: data,
  }
}
export function setSpanishNegativeResponseData(data) {
  return {
    type: SETSPANISHNEGATIVERESPONSEDATA,
    data: data,
  }
}
export function setScheduleData(data) {
  return {
    type: SETSCHEDULEDATA,
    data: data,
  }
}
export function setCIData(data) {
  return {
    type: SETCIDATA,
    data: data,
  }
}
export function setListInputData(data) {
  return {
    type: SETLISTINPUTDATA,
    data: data,
  }
}
export function setListInputType(data) {
  return {
    type: SETLISTINPUTTYPE,
    data: data,
  }
}
export function homepageCreate(
  blossomID,
  contactList,
  contactMethod,
  primaryJobCodesList,
  failoverJobCodesList,
  notifySupervisorJobCodesList,
  contactDelay,
  distance,
  workerType,
  schedule,
  messageTitle,
  messageBodyPhone,
  messageBodySMS,
  messageBodyEmail,
  messageResponsePositive,
  messageResponseNegative,
  messageResponsePositiveEs,
  messageResponseNegativeEs,
) {
  // Only include locations or distribution lists that are marked as true
  var contactListArray = []
  var contactPreListArray = Object.entries(contactList)
  for (const [contactListItem, bool] of contactPreListArray) {
    if (bool) {
      contactListArray.push(contactListItem)
    }
  }

  // Added the below to add in distros for 2 business groups, the distros will always be notified in every alert
  switch (blossomID) {
    case 'ceebackup':
      contactListArray.push('C3.Oncall@Target.com')
      break
    case 'precall':
      contactListArray.push('F&B-FoodBevDirectors-Field@Target.com')
      contactListArray.push('F&B-FBC@Target.com')
      contactListArray.push('FC-FieldTeam@Target.com')
      break
    default:
  }

  var contactType = ['phone', 'sms', 'email']
  var personalValues = [false, false, false]
  var workValues = [false, false, false]

  for (var i = 0; i < contactMethod.length; i++) {
    contactType[i] = String(contactMethod[i]['text']).toLowerCase()

    if (contactMethod[i]['checked']) {
      // compare to CI
      switch (blossomID) {
        case 'bcp':
          switch (contactType[i]) {
            case 'phone':
              personalValues[i] = true
              workValues[i] = true
              break
            case 'sms':
              personalValues[i] = true
              workValues[i] = true
              break
            case 'email':
              personalValues[i] = false
              workValues[i] = true
              break
            default:
              personalValues[i] = false
              workValues[i] = false
          }
          break
        case 'precall':
          switch (contactType[i]) {
            case 'phone':
              personalValues[i] = false
              workValues[i] = false
              break
            case 'sms':
              personalValues[i] = true
              workValues[i] = true
              break
            case 'email':
              personalValues[i] = false
              workValues[i] = true
              break
            default:
              personalValues[i] = false
              workValues[i] = false
          }
          break
        case 'c3alert':
          switch (contactType[i]) {
            case 'phone':
              personalValues[i] = true
              workValues[i] = true
              break
            case 'sms':
              personalValues[i] = true
              workValues[i] = true
              break
            case 'email':
              personalValues[i] = false
              workValues[i] = true
              break
            default:
              personalValues[i] = false
              workValues[i] = false
          }
          break
        case 'c3aalert':
          switch (contactType[i]) {
            case 'phone':
              personalValues[i] = true
              workValues[i] = true
              break
            case 'sms':
              personalValues[i] = true
              workValues[i] = true
              break
            case 'email':
              personalValues[i] = false
              workValues[i] = true
              break
            default:
              personalValues[i] = false
              workValues[i] = false
          }
          break
        case 'developer':
          switch (contactType[i]) {
            case 'phone':
              personalValues[i] = true
              workValues[i] = true
              break
            case 'sms':
              personalValues[i] = true
              workValues[i] = true
              break
            case 'email':
              personalValues[i] = false
              workValues[i] = true
              break
            default:
              personalValues[i] = false
              workValues[i] = false
          }
          break
        case 'shipt':
          switch (contactType[i]) {
            case 'phone':
              personalValues[i] = true
              workValues[i] = true
              break
            case 'sms':
              personalValues[i] = true
              workValues[i] = true
              break
            case 'email':
              personalValues[i] = false
              workValues[i] = true
              break
            default:
              personalValues[i] = false
              workValues[i] = false
          }
          break
        case 'ceebackup':
          switch (contactType[i]) {
            case 'phone':
              personalValues[i] = false
              workValues[i] = false
              break
            case 'sms':
              personalValues[i] = false
              workValues[i] = true
              break
            case 'email':
              personalValues[i] = false
              workValues[i] = true
              break
            default:
              personalValues[i] = false
              workValues[i] = false
          }
          break
        case 'CI00598283':
          switch (contactType[i]) {
            case 'phone':
              personalValues[i] = true
              workValues[i] = false
              break
            case 'sms':
              personalValues[i] = true
              workValues[i] = false
              break
            case 'email':
              personalValues[i] = true
              workValues[i] = true
              break
            default:
              personalValues[i] = false
              workValues[i] = false
          }
          break
        case 'fmocdc':
          switch (contactType[i]) {
            case 'phone':
              personalValues[i] = false
              workValues[i] = false
              break
            case 'sms':
              personalValues[i] = false
              workValues[i] = true
              break
            case 'email':
              personalValues[i] = false
              workValues[i] = true
              break
            default:
              personalValues[i] = false
              workValues[i] = false
          }
          break
        default:
          switch (contactType[i]) {
            case 'phone':
              personalValues[i] = false
              workValues[i] = false
              break
            case 'sms':
              personalValues[i] = false
              workValues[i] = false
              break
            case 'email':
              personalValues[i] = false
              workValues[i] = false
              break
            default:
              personalValues[i] = false
              workValues[i] = false
          }
      }
    } else {
      personalValues[i] = false
      workValues[i] = false
    }
  }

  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching2(true))
        axios
          .post(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/campaigns/start?key=' +
              encodeURIComponent(apiKey),
            {
              group_id: blossomID,
              contact_list: contactListArray,
              filter: {
                contact_method: {
                  [contactType[0]]: {
                    personal: personalValues[0],
                    work: workValues[0],
                  },
                  [contactType[1]]: {
                    personal: personalValues[1],
                    work: workValues[1],
                  },
                  [contactType[2]]: {
                    personal: personalValues[2],
                    work: workValues[2],
                  },
                },
                job_code: {
                  primary: primaryJobCodesList,
                  secondary: failoverJobCodesList,
                },
                contact_delay: contactDelay,
                contact_distance: distance,
                contact_distance_worker_types: workerType,
                notify_supervisor_job_codes: notifySupervisorJobCodesList,
              },
              schedule: latestDate(schedule),
              message: {
                message_title: messageTitle,
                message_body_phone: messageBodyPhone,
                message_body_sms: messageBodySMS,
                message_body_email: messageBodyEmail,
                message_response_positive: messageResponsePositive,
                message_response_negative: messageResponseNegative,
                message_response_positive_es: messageResponsePositiveEs,
                message_response_negative_es: messageResponseNegativeEs,
              },
            },
          )
          .then(function (response) {
            dispatch(homepageCreateResponseData(response))
            dispatch(apiFetching2(false))
          })
          .catch(function (error) {
            // removed error from function
            dispatch(homepageCreateErrorData(error.response))
            dispatch(apiFetching2(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching2(false))
      })
  }
}

function homepageCreateResponseData(response) {
  return {
    type: HOMEPAGECREATE,
    data: response.data,
  }
}

function homepageCreateErrorData(response) {
  return {
    type: HOMEPAGECREATEERROR,
    errorData: response.status,
  }
}

function apiFetching2(status) {
  return {
    type: FETCH2,
    fetching: status,
  }
}
function latestDate(scheduleDataFromChild) {
  var date = new Date()
  date.setSeconds(0, 0)
  if (scheduleDataFromChild < date) {
    return date
  }
  return scheduleDataFromChild
}
